var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "facebook-circular-logo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_910",
    "data-name": "Path 910",
    d: "M15,.349a15.059,15.059,0,0,0-2.5,29.9V18.554H8.88V14.346H12.5v-3.1c0-3.6,2.19-5.562,5.389-5.562a29.739,29.739,0,0,1,3.231.165V9.609H18.9c-1.739,0-2.075.83-2.075,2.048v2.686h4.15l-.541,4.208H16.825v11.8A15.059,15.059,0,0,0,15,.349Z",
    transform: "translate(0 -0.349)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookicon);
export default __webpack_public_path__ + "static/media/facebook icon.45566e2ec9d0006166e421dad4269e8b.svg";
export { ForwardRef as ReactComponent };